"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.analyticsStore = void 0;
var analytics_1 = require("./analytics");
Object.defineProperty(exports, "analyticsStore", { enumerable: true, get: function () { return analytics_1.analyticsStore; } });
//# sourceMappingURL=index.js.map